import { userResourceVO } from '../../admin-users/models/userVO.model';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { ApplicationVO } from '../../admin-users/models/application';

export class ApplicationProfilesVO {
  profileId: number;
  name: string;
  description: string;
  applicationId: number
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  profilePermissionXrefs: ProfilePermissionXrefVO[]
  application: ApplicationVO;
  userResourceVOList: userResourceVO[]
}
export class ProfilePermissionXrefVO {
  xrefId: number;
  profileId: number;
  permissionId: number;
  permission: PermissionVO;
  permissionValue: string;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
}
export class PermissionVO {
  permissionId: number;
  permissionName: string;
  resource: ResourceVO;
  resourceId: number;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  profilePermissionXrefs: ProfilePermissionXrefVO
}
export class ResourceVO {
  resourceId: number;
  name: string;

  applicationId: number;
  type: string;
  category: string;
  parentId: number;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  permissions: PermissionVO;
}

export class ProfileResponse {
  apiResponseVO: ApiResponse;
  profilesVOList: ApplicationProfilesVO;
}
export class ProfilePermissionXrefResponse {
  apiResponseVO: ApiResponse;
  profilePermissionXrefs: ProfilePermissionXrefVO[];
}